import { render, staticRenderFns } from "./copilot.vue?vue&type=template&id=b62364c4&scoped=true"
import script from "./copilot.vue?vue&type=script&lang=js"
export * from "./copilot.vue?vue&type=script&lang=js"
import style0 from "./copilot.vue?vue&type=style&index=0&id=b62364c4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b62364c4",
  null
  
)

export default component.exports